/* eslint-disable no-console */
import React, { useEffect } from 'react';

const SaveCSVFile = (props) => {
  const { data, closeCSV } = props;
  const handleSave = () => {
    /* for text only */
    /* const content = "This is the content to be saved.";
    const blob = new Blob([content], { type: 'text/plain' });
    const file = new File([blob], 'saved-file.txt', { type: blob.type }); */

    /* for JSON only */
    /* const jsonContent = JSON.stringify({ key: 'value' });
     const blob = new Blob([jsonContent], { type: 'application/json' });
     const file = new File([blob], 'saved-file.txt', { type: blob.type }); */

    const content = data.map(row => row.join(',')).join('\n');
    const blob = new Blob([content], { type: 'text/csv' });
    const file = new File([blob], 'StreamData.csv', { type: blob.type });
    if (window.showSaveFilePicker) {
      window.showSaveFilePicker({
        suggestedName: file.name,
        types: [{
          description: 'CSV File',
          accept: { 'text/csv': ['.csv'] },
        }],
      }).then((handle) => {
        handle.createWritable().then((writable) => {
          writable.write(file).then(() => {
            writable.close();
            closeCSV();
          });
        });
      }).catch((err) => {
        closeCSV();
        console.error('Failed to save file:', err);
      });
    } else {
      // Fallback for browsers that don't support showSaveFilePicker
      const url = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = url;
      link.download = file.name;
      link.click();
      URL.revokeObjectURL(url);
      closeCSV();
    }
  };
  useEffect(() => {
    handleSave();
  }, []);
  return (
    <div style={{ display: 'none' }} />
  );
};

export default SaveCSVFile;